import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { GoogleMap, MapMarker, MapInfoWindow } from '@angular/google-maps';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-map',
  templateUrl: './app-map.component.html',
})
export class AppMapComponent extends FieldComponent implements OnInit {
  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;
  @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;

  @Input() editable = true;
  @Input() zoom = 16;
  marker: any;
  infoContent = '';

  center: google.maps.LatLngLiteral;
  mapOptions: google.maps.MapOptions = {
    mapTypeId: 'hybrid',
    zoomControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    maxZoom: 15,
    minZoom: 8,
  };

  override start() {
    super.start();
    navigator.geolocation.getCurrentPosition((position) => {
      this.center = {
        lat: this.value[0] ?? position.coords.latitude,
        lng: this.value[1] ?? position.coords.longitude,
      };
    });
    this.center = {
      lat: this.value[0],
      lng: this.value[1],
    }

    this.marker = {
      position: {
        lat: this.value[0] ?? this.center.lat,
        lng: this.value[1] ?? this.center.lng,
      },
      // label: { color: 'red', text: 'Marker label ' },
      // title: 'Marker title',
      options: { animation: google.maps.Animation.BOUNCE },
    }
  }

  override updateValue() {
    super.updateValue();
    this.center = {
      lat: this.value[0],
      lng: this.value[1],
    }
    this.marker = {
      position: {
        lat: this.value[0],
        lng: this.value[1],
      },
    }
  }

  zoomIn() {
    if (this.zoom < this.mapOptions.maxZoom) this.zoom++;
  }

  zoomOut() {
    if (this.zoom > this.mapOptions.minZoom) this.zoom--;
  }

  logCenter() {
    // console.log(JSON.stringify(this.map.getCenter()));
  }

  clickOnMap(event) {
    if (!this.editable) { return; }
    this.value = [+event?.latLng?.lat() ?? 0, +event?.latLng?.lng() ?? 0];
    this.marker = {
      position: {
        lat: this.value[0] ?? this.center.lat,
        lng: this.value[1] ?? this.center.lng,
      },
      // label: { color: 'red', text: 'Marker label ' },
      // title: 'Marker title',
      options: { animation: google.maps.Animation.BOUNCE },
    }
    this.updateObject();
    this.onChangeContent();
  }

  openInfo(marker: MapMarker, content) {
    this.infoContent = content;
    this.infoWindow.open(marker);
  }

  inputChanged2() {
    this.value = [+this.value[0], +this.value[1]];
    this.inputChanged();
  }
}
